import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchDeliveryProducts(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/manage_delivery_products/${delivery_process_id}/fetch_delivery_products`
    );
  },

  update(
    service_provider_id,
    delivery_process_id,
    id,
    delivery_product
  ) {
    return RequesterV1.post(
      `service_provider/delivery/managing/${service_provider_id}/manage_delivery_products/${delivery_process_id}/update/${id}`,
      { delivery_product }
    );
  },
};
